import _classCallCheck from "D:/work-station/training-cloud/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/work-station/training-cloud/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "D:/work-station/training-cloud/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "D:/work-station/training-cloud/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate, __metadata } from "tslib";
import { Vue, Prop, Component } from "vue-property-decorator";

var MyButton = /*#__PURE__*/function (_Vue) {
  _inherits(MyButton, _Vue);

  var _super = _createSuper(MyButton);

  function MyButton() {
    _classCallCheck(this, MyButton);

    return _super.apply(this, arguments);
  }

  _createClass(MyButton, [{
    key: "mounted",
    value: function mounted() {
      this.toCourseEdit();
    }
  }, {
    key: "toCourseEdit",
    value: function toCourseEdit() {}
  }]);

  return MyButton;
}(Vue);

__decorate([Prop(), __metadata("design:type", String)], MyButton.prototype, "title", void 0);

MyButton = __decorate([Component({
  components: {}
})], MyButton);
export default MyButton;